import { Pipe, PipeTransform } from '@angular/core';
import { ToWords } from './classes/to-words';

@Pipe({
  name: 'currencyWords',
})
export class CurrencyWordsPipe implements PipeTransform {
  transform(value: number): string {
    if (value) {
      var tw = new ToWords({
        localeCode: 'en-US',
        converterOptions: {
          currency: true,
          ignoreDecimal: false,
          ignoreZeroCurrency: true,
        },
      });
      var amountInWords = tw.convert(value);
      return amountInWords;
    } else {
      return '';
    }
  }
}
